/** @jsx jsx */

import { jsx } from '@emotion/core';
import { TimePeriodDays } from 'app/developer-v3/hooks/useIntegrationInsights';
import { Icon } from '@zapier/zinnia-icons';
import { Text } from '@zapier/design-system';
import { BaseTile, BaseTileState } from './BaseTile';
import DateRangeDropdown from '../DateRangeDropdown';
import { defaultInitialSelectedItem, timePeriodDaysItems } from '../utils';
import CountDisplay from '../CountDisplay';

type ActiveZapsTileProps = {
  activeZapsCount: number;
  dataTestId?: string;
  onSelect: (value: TimePeriodDays) => void;
} & Omit<BaseTileState, 'isNoData'>;

export const ActiveZapsTile = ({
  isLoading,
  isError,
  activeZapsCount,
  dataTestId,
  onSelect,
}: ActiveZapsTileProps) => (
  <BaseTile
    dataTestId={dataTestId}
    dropdowns={[
      <DateRangeDropdown
        initialSelectedItem={defaultInitialSelectedItem}
        items={timePeriodDaysItems}
        onSelect={period => onSelect(period as TimePeriodDays)}
      />,
    ]}
    headerContent="Active Zap workflows"
    icon={<Icon name="miscBoltAlt" size="24px" />}
    isError={isError}
    isLoading={isLoading}
    isNoData={activeZapsCount === undefined || activeZapsCount === null}
    toolTipContent={
      <Text color="PrimeWhite" type="Body1">
        Total number of active Zap workflows over a selected period of time.
        Active Zap workflows = number of Zap workflows using this integration.
      </Text>
    }
  >
    <CountDisplay count={activeZapsCount} />
  </BaseTile>
);

export default ActiveZapsTile;
